<template>
    <div :class="{'h-11 w-24 mb-0.5 bg-gray-300 animate-pulse' : isSkeleton}">
        <div v-if="!isSkeleton"
             class="flex
                    flex-row
                    -mb-1 strikethrough">
            <span class="text-xl
                         font-bold
                         leading-none
                       text-gray-400
                         -mt-1">
                <!--
                <span v-if="showPlus"
                      class="text-gray-400
                             font-normal">+</span>-->
                $
            </span>
            <span class="text-5xl
                         font-heavy
                         text-gray-400
                         ml-0.5
                         mr-1
                         -mt-2"
                  :class="getSize">
                {{ dollar }}
            </span>
            <div class="flex
                        flex-col
                        text-left">
                <span class="font-bold
                             leading-none
                             text-gray-400
                             text-sm
                             whitespace-nowrap">{{ cents }}

                </span>
                <span class="text-xs
                             leading-none
                             text-gray-400">/mo</span>
                <span v-if="note"
                      class="text-xs
                             leading-none">{{ note }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import SlottedModal from '@/organisms/SlottedModal'

    export default {
        name: 'PrevPricePerMonth',
        components: {
            SlottedModal,
        },
        props: {
            price: {
                type: Number,
                required: true,
            },
            fullPrice: {
                type: Number,
                default: null,
            },
            note: {
                type: String,
                required: false,
                default: null,
            },
            showPlus: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: null,
                validator: val => [
                    null,
                    'small',
                    'large',
                ].includes(val),
            },
            isSkeleton: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            getSize(){
                return {
                    small: 'text-3xl',
                    large: 'text-6xl tablet:text-8xl leading-none tablet:leading-16',
                }[this.size] || 'leading-none'
            },
            normalizedPrice () {
                return this.price.toFixed(2).split('.')
            },
            dollar () {
                return this.normalizedPrice[0]
            },
            cents () {
                return this.normalizedPrice[1]
            },
        }
    }
</script>

<style lang="scss" scoped>
.strikethrough {
  position: relative;
}

.strikethrough:before {
    position: absolute;
    content: "";
    left: 0;
    top: 37%;
    right: 0;
    border-top: 5px solid;
    border-color: salmon;
    transform: rotate(340deg);
}
</style>
